<template>
  <div class="main" >
    <div v-if="isShowArrows">
      <img class="arrowsImg arrows_up" v-show="isShow" :src="arrows_up" alt="" @click="isShow = !isShow">
      <img class="arrowsImg arrows_down" v-show="!isShow" :src="arrows_down" alt="" @click="isShow = !isShow">
    </div>
    <!-- 资源分类 -->
    <div v-show="isShow && showCategory" class="content">
      <div class="title">资源分类：</div>
      <div class="area">
        <span
          v-for="(item, index) in resourceDatas"
          :key="index"
          @click="changeFunc(item.id, 'resource')"
          :class="{'actived': item.id == categoryId }"
          >{{ item.categoryName }}</span
        >
      </div>
    </div>
    <!-- 素材文件格式 -->
    <div v-if="isShow && from == 'conditionList'" class="content">
      <div class="title">文件格式：</div>
      <div class="area">
        <span
          v-for="(item, index) in fileTypeList"
          :key="index"
          @click="changeFunc(item.id, 'fileType')"
          :class="{'actived': item.id == id}"
        >{{ item.name }}
          </span>
      </div>
    </div>
    <!-- 试题类型 -->
    <div v-show="isShow && from == 'question'" class="content">
      <div class="title">试题类型：</div>
      <div class="area">
        <span
          v-for="(item, index) in questiontypeDatas"
          :key="index"
          @click="changeFunc(item.id, 'questionType', item.internaltypeid)"
          :class="{'actived': item.id == questiontypeId }"
          >{{ item.questiontypeName }}</span
        >
      </div>
    </div>
    <!-- 试题难度 -->
    <div v-show="isShow && from == 'question'" class="content">
      <div class="title">试题难度：</div>
      <div class="area">
        <span
          v-for="(item, index) in difficultyData"
          :key="index"
          @click="changeFunc(item.id, 'difficulty')"
          :class="{'actived': item.id == difficultyId }"
          >{{ item.label }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../api/newCourseApi"
export default {
  name: "resourceClassify",
  components: {},
  data() {
    return {
      isShow: true,
        id: '',
      arrows_up: require("@/assets/icon/icon_arrows_up.png"),
      arrows_down: require("@/assets/icon/icon_arrows_down.png"),
      categoryId: "", //资源分类id
      resourceDatas: [],
      questiontypeId: "",
      questiontypeDatas: [],
      difficultyId: "",
      difficultyData: [
        { id: "", label: "全部", },
        { id: 1, label: "简单", },
        { id: 2, label: "中等", },
        { id: 3, label: "困难", },
      ],
      courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
    };
  },
  props: {
    courseId: {
      type: [Number, String],
      default: ""
    },
    fileTypeList: Array,
    subjectId: {
      type: [Number, String],
      default: ""
    },
    from: {
      type: String,
      default: ""
    },
    isShowArrows: {
      type: Boolean,
      default: true
    },
    isShowShiCao: {
      type: Boolean,
      default: true
    },
    isShowOtherTypes: {
      type: Boolean,
      default: true
    },
    showCategory: { // 是否显示资源分类(组卷 有大资源库权限时 不显示)
      type: Boolean,
      default: true
    }
  },
  created() {},
  mounted() {
    this.findResCategoryByCourseId(this.courseId ? this.courseId : this.$route.query.id || this.$parent.query.id);
    if (this.from == "question") {
      this.findTypeBySubject();
    }
  },
  methods: {
    // 查询资源分类
    findResCategoryByCourseId(id) {
      api.FindResCategoryByCourseId(id).then(res => {
        if (res.code == "0") {
          // 录试题 默认加入到 资源-其他
          if (res.data.length > 0) {
            this.$emit('initCategory', res.data)
          }

          let data = res.data;
          data.unshift({
            categoryName: "全部",
            id: ""
          })
          this.resourceDatas = data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    // 查询试题类型
    findTypeBySubject() {
      // 1标准模式 查findTypeByModel
      let apiUrl = this.courseModel != 1 && this.subjectId ? api.FindTypeBySubject({subjectId: this.subjectId}) : api.findTypeByModel({typeModel: 1});

      apiUrl.then(res => {
        if (res.code == "0") {
          let data = res.data;
          data.unshift({
            questiontypeName: "全部",
            id: ""
          });
          this.questiontypeDatas = data;
          // 课程编辑/试卷，新建组卷时，过滤掉实操题类型
          if (!this.isShowShiCao) {
            this.questiontypeDatas = this.questiontypeDatas.filter(item => item.internaltypeid !== 9)
          }
          // 课程编辑/试题，暂时过滤掉 除(单，多，判，实操), 如 不定项6，
          if (!this.isShowOtherTypes) {
            this.questiontypeDatas = this.questiontypeDatas.filter(item => item.internaltypeid !== 6)
          }
          this.$emit('initQuestionType', this.questiontypeDatas)
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    changeFunc(id, type, systemId) {
      type == "resource" ? this.categoryId = id : type == "questionType" ? this.questiontypeId = id : this.difficultyId = id;
      if(type === 'fileType'){
          this.id = id
      }
      this.$emit("changeFunc", id, type, systemId)
    },
    changeCategoryId(val){
      this.categoryId = val
    }
  },
};
</script>

<style scoped lang="scss">
.main {
  font-size: 12px;
  line-height: 24px;
  position: relative;
  .arrowsImg {
    width: 18px;
    height: 6px;
    position: absolute;
    right: 50px;
    cursor: pointer;
  }
  .arrows_up {
    top: -16px;
  }
  .arrows_down {
    top: -10px;
  }
  .title {
    color: #767484;
  }
  .content {
    display: flex;
    margin-bottom: 10px;
  }
  .area {
    flex: 1;
    span {
      display: inline-block;
      padding: 0px 12px;
      cursor: pointer;
      height: 24px;
      border-radius: 4px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-size: 12px;
      font-weight: 400;
      color: #767484;
      background: #F5F5F7;
      margin-right: 8px;
      margin-bottom: 8px;
      &:hover {
        color: #1890FF;
      }
    }

    .actived {
      background: linear-gradient(315deg, #69D5FF 0%, #0084FF 100%);
      color: #FFFFFF;
      font-weight: 600;
      &:hover {
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/resourceClassify.vue